<template>
    <div>
        <!-- 内容 -->
        <div class="wrapper">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>

import Header from './Header.vue'

export default {
    components:{
        Header
    }
}
</script>

<style>
.wrapper{
    /* height: 100vh; */
    height: 90vh;
    /* padding: 160px 20px 20px 20px; */
    background: #012430;
    min-width: 1322px;
}
</style>